<template>
    <v-card class="py-4 px-2">
        <p class="d-flex justify-content-center bg-light p-3 text-caption">Under development..</p>

       
    </v-card>
</template>

<script>
export default {
    name: "ComplianceLimitation",
    // props: {
    //     selectedRemitee: {
    //         type: Object,
    //         required: true
    //     }
    // },
    data: () => {
        return {

        }
    }
}
</script>